import React from "react";
import CompactBanner from "./CompactBanner";

function NoDomainDetectedBanner() {
  return <CompactBanner type="error" text="Domain required to publish your form" />;
}

export default React.memo(NoDomainDetectedBanner);
